export default "__VITE_ASSET__CTO5i1pO__"